/* eslint-disable react-hooks/exhaustive-deps */

import Label from "@components/general/Label";
import Translate from "@service/Translate";
import { FC, useState } from "react";

interface IMapWidgetProps {
    dataSource: string[];
    onChangeDataSourceTagsGroups?: (dataSourceTags: string[]) => void;
}

export const DataSourceTags: FC<IMapWidgetProps> = ({ dataSource, onChangeDataSourceTagsGroups }) => {
    const { tr } = Translate;
    const [selectedDataSourceTags, setSelectedDataSourceTags] = useState<string[]>([]);

    const onMarkerGroupsValueChange = (tag: string) => {
        if (!selectedDataSourceTags.some(x => x === tag))
            selectedDataSourceTags.push(tag);
        else
            selectedDataSourceTags.splice(selectedDataSourceTags.findIndex(x => x === tag), 1);
        setSelectedDataSourceTags(selectedDataSourceTags.slice());
        onChangeDataSourceTagsGroups && onChangeDataSourceTagsGroups(selectedDataSourceTags);
    }

    return (
        <div className="data-source-tags">
            <ul className="data-source-tags-items row spa-2 flex">
                {dataSource.map((tag, index) =>
                    <li key={index} className="col-1-auto">
                        <div
                            className={`data-source-tags-item flex flex-center ${selectedDataSourceTags?.find(x => x === tag) ? "selected" : ""}`}
                            onClick={() => onMarkerGroupsValueChange(tag)}
                        >
                            <Label
                                mode="inline"
                                size="medium"
                                icon={`icon-${tag.toLowerCase()}`}
                                text={tr(`${tag.toLowerCase()}`)}
                            />
                        </div>
                    </li>
                )}
            </ul>
        </div>
    )
}

export default DataSourceTags;